import {
  Alert,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Snackbar,
  Typography,
} from '@mui/material';
import { useCreateOrganization } from '_api/mutations/organizations';
import { OrganizationPayload } from '_api/types';
import { DefaultNewOrganization } from '_constants/object-templates';
import { OrganizationForm } from 'components/organisms/forms';
import React, { useState } from 'react';
import { IoMdClose } from 'react-icons/io';

import { ModalProps } from './types';

export const AddOrganization = ({ open, onClose }: ModalProps) => {
  const { mutateAsync: createOrg } = useCreateOrganization();
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const onSubmit = (submitOrg: OrganizationPayload) => {
    createOrg(submitOrg)
      .then((data) => {
        if (data && data.id) {
          setShowSuccess(true);
          setTimeout(() => onClose(), 1500);
        }
      })
      .catch(() => setShowError(true));
  };
  return (
    <Dialog fullWidth={true} maxWidth={'lg'} open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          paddingTop: 8,
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'left' }}>
          Add Organization
        </Typography>
        <IconButton aria-label="close" onClick={onClose} sx={{ marginRight: 5 }}>
          <IoMdClose />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <OrganizationForm
          disableAll={showSuccess}
          initValue={DefaultNewOrganization}
          onBack={onClose}
          onSubmit={onSubmit}
        />
      </DialogContent>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={5000}
        onClose={() => setShowSuccess(false)}
        open={showSuccess}
      >
        <Alert onClose={() => setShowSuccess(false)} severity="success" variant="filled">
          Organization Successfully created
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={5000}
        onClose={() => setShowError(false)}
        open={showError}
      >
        <Alert onClose={() => setShowError(false)} severity="error" variant="filled">
          Failed to create Organization. Resolve form issues and try again.
        </Alert>
      </Snackbar>
    </Dialog>
  );
};
